import React from 'react';
import { Drawer, Typography } from 'antd';
import ScheduleActivityTimeline from '../../features/flightSchedule/OfficialList/components/ScheduleActivityTimeline';

const { Title } = Typography;

/**
 * 计划活动记录抽屉组件
 * 用于在列表页面中显示计划的活动记录
 */
const ScheduleActivityDrawer = ({ 
  visible, 
  onClose, 
  scheduleId, 
  scheduleName,
  title = "活动记录"
}) => {
  return (
    <Drawer
      title={
        <div>
          <Title level={4} style={{ margin: 0 }}>
            {title}
          </Title>
          {scheduleName && (
            <div style={{ 
              fontSize: '14px', 
              color: '#666', 
              marginTop: '4px' 
            }}>
              计划：{scheduleName}
            </div>
          )}
        </div>
      }
      width={800}
      placement="right"
      onClose={onClose}
      visible={visible}
      destroyOnHidden={true}
      bodyStyle={{ padding: '16px' }}
    >
      {scheduleId && (
        <ScheduleActivityTimeline scheduleId={scheduleId} />
      )}
    </Drawer>
  );
};

export default ScheduleActivityDrawer; 